/**
 * Shell com menu lateral para telas de PILHA (fora das abas) que, no desktop, não devem
 * "sumir" com a navegação do app — ex.: chat de suporte, atualização cadastral.
 *
 * < 1024px: o menu lateral fica oculto (CSS) e a tela ocupa tudo, como no app — idêntico.
 * ≥ 1024px: menu lateral à esquerda + tela à direita, como nas abas (sem a barra inferior).
 * ≥ 1440px: painel lateral direito (relógio, sincronização, calendário) igual ao das abas,
 * para as laterais seguirem o mesmo padrão das outras telas.
 * O chat aberto como PRESTADOR (`?perfil=prestador`) não usa o menu do colaborador.
 */
import PainelLateralDesktop from "@/components/desktop/PainelLateralDesktop";
import MenuLateral from "@/components/navigation/MenuLateral";
import { useLocalSearchParams } from "@/navigation";
import { useRef } from "react";
import { Outlet } from "react-router";
import { useFaixaSincronizada } from "./(tabs)/useFaixaSincronizada";
import s from "./(tabs)/TabsLayout.module.css";

export default function ShellLateral() {
  const { perfil } = useLocalSearchParams<{ perfil?: string }>();
  if (perfil === "prestador") return <Outlet />;
  return <ShellComMenu />;
}

function ShellComMenu() {
  const mainRef = useRef<HTMLElement | null>(null);
  useFaixaSincronizada(mainRef);
  return (
    <div className={s.raiz}>
      <aside className={s.lateral}>
        <MenuLateral />
      </aside>
      <div className={s.coluna}>
        <main ref={mainRef} className={s.conteudo}>
          <Outlet />
        </main>
      </div>
      <aside className={s.painelDireito}>
        <PainelLateralDesktop />
      </aside>
    </div>
  );
}
